<template>
  <svg
    width="967"
    height="314"
    viewBox="0 0 967 314"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <text
      fill="white"
      xml:space="default"
      style="white-space: nowrap"
      font-family="Inter"
      font-size="48"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="0" y="48.4545">Bitcoin&#39;s UTXO Data Consensus Protocol&#13;&#10;</tspan>
      <tspan x="0" y="110.455">is an open and decentralized&#13;&#10;</tspan>
      <tspan x="0" y="172.455">hybrid consensus mechanism</tspan>
    </text>
    <text
      fill="#BFBFBF"
      xml:space="default"
      style="white-space: nowrap"
      font-family="Inter"
      font-size="16"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="0" y="219.818">
        Bitcoin&#39;s metadata sync protocol merges PoW and PoS consensus to ensure accurate
      </tspan>
      <tspan x="0" y="243.818">
        synchronization, with fully open-source code and data for community audit and verification.
      </tspan>
    </text>
    <path
      d="M0 278C0 271.373 5.37258 266 12 266H168C174.627 266 180 271.373 180 278V302C180 308.627 174.627 314 168 314H12C5.37258 314 0 308.627 0 302V278Z"
      fill="#F0F0F0"
    />
    <text
      fill="#1F1F1F"
      xml:space="preserve"
      style="white-space: pre; cursor: pointer"
      font-family="Inter"
      font-size="16"
      font-weight="600"
      letter-spacing="0.01em"
      @click="handleClick"
    >
      <tspan x="20" y="295.818">Protocol Explorer</tspan>
    </text>
  </svg>
</template>

<script setup>
const handleClick = () => {
  window.open('https://utxoverse.xyz/dashboard', '_blank')
}
</script>

<style scoped></style>
